/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * Contact: redjar.redelivery@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { DeliveryInputDto } from '../model/deliveryInputDto';
import { DeliveryNewPasswordDto } from '../model/deliveryNewPasswordDto';
import { DeliveryOutputDto } from '../model/deliveryOutputDto';
import { DeliveryRequestDto } from '../model/deliveryRequestDto';
import { DeliveryResponseDto } from '../model/deliveryResponseDto';
import { DeliveryUpdateDto } from '../model/deliveryUpdateDto';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { ParticularOrderOutputDto } from '../model/particularOrderOutputDto';
import { WaypointStatus } from '../model/enumWaypointStatus';

export interface PaginatedParticularOrdersResponse {
  data: ParticularOrderOutputDto[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  hasPrevious: boolean;
  hasNext: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class DeliveryService {
  protected basePath = '/';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   *
   *
   * @param cdDelivery
   * @param state
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiDeliveryActiveInactivePut(
    cdDelivery?: number,
    state?: boolean,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<DeliveryOutputDto>;
  public apiDeliveryActiveInactivePut(
    cdDelivery?: number,
    state?: boolean,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<DeliveryOutputDto>>;
  public apiDeliveryActiveInactivePut(
    cdDelivery?: number,
    state?: boolean,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<DeliveryOutputDto>>;
  public apiDeliveryActiveInactivePut(
    cdDelivery?: number,
    state?: boolean,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (cdDelivery !== undefined && cdDelivery !== null) {
      queryParameters = queryParameters.set('cdDelivery', <any>cdDelivery);
    }
    if (state !== undefined && state !== null) {
      queryParameters = queryParameters.set('state', <any>state);
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization']
      );
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<DeliveryOutputDto>(
      'put',
      `${this.basePath}/api/Delivery/ActiveInactive`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiDeliveryChangePasswordPut(
    body?: DeliveryNewPasswordDto,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<boolean>;
  public apiDeliveryChangePasswordPut(
    body?: DeliveryNewPasswordDto,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<boolean>>;
  public apiDeliveryChangePasswordPut(
    body?: DeliveryNewPasswordDto,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<boolean>>;
  public apiDeliveryChangePasswordPut(
    body?: DeliveryNewPasswordDto,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization']
      );
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<boolean>(
      'put',
      `${this.basePath}/api/Delivery/ChangePassword`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   *
   *
   * @param cdDelivery
   * @param qtLat
   * @param qtLng
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiDeliveryDeliveryPositionPut(
    cdDelivery?: number,
    qtLat?: number,
    qtLng?: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<boolean>;
  public apiDeliveryDeliveryPositionPut(
    cdDelivery?: number,
    qtLat?: number,
    qtLng?: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<boolean>>;
  public apiDeliveryDeliveryPositionPut(
    cdDelivery?: number,
    qtLat?: number,
    qtLng?: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<boolean>>;
  public apiDeliveryDeliveryPositionPut(
    cdDelivery?: number,
    qtLat?: number,
    qtLng?: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (cdDelivery !== undefined && cdDelivery !== null) {
      queryParameters = queryParameters.set('cdDelivery', <any>cdDelivery);
    }
    if (qtLat !== undefined && qtLat !== null) {
      queryParameters = queryParameters.set('qtLat', <any>qtLat);
    }
    if (qtLng !== undefined && qtLng !== null) {
      queryParameters = queryParameters.set('qtLng', <any>qtLng);
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization']
      );
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<boolean>(
      'put',
      `${this.basePath}/api/Delivery/DeliveryPosition`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiDeliveryEditPut(
    body?: DeliveryUpdateDto,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<DeliveryOutputDto>;
  public apiDeliveryEditPut(
    body?: DeliveryUpdateDto,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<DeliveryOutputDto>>;
  public apiDeliveryEditPut(
    body?: DeliveryUpdateDto,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<DeliveryOutputDto>>;
  public apiDeliveryEditPut(
    body?: DeliveryUpdateDto,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization']
      );
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<DeliveryOutputDto>(
      'put',
      `${this.basePath}/api/Delivery/Edit`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   *
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiDeliveryGetAllGet(
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<DeliveryOutputDto>>;
  public apiDeliveryGetAllGet(
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<DeliveryOutputDto>>>;
  public apiDeliveryGetAllGet(
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<DeliveryOutputDto>>>;
  public apiDeliveryGetAllGet(
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization']
      );
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Array<DeliveryOutputDto>>(
      'get',
      `${this.basePath}/api/Delivery/GetAll`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   *
   *
   * @param cdDriver
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiDeliveryGetOneGet(
    cdDriver?: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<DeliveryOutputDto>;
  public apiDeliveryGetOneGet(
    cdDriver?: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<DeliveryOutputDto>>;
  public apiDeliveryGetOneGet(
    cdDriver?: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<DeliveryOutputDto>>;
  public apiDeliveryGetOneGet(
    cdDriver?: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (cdDriver !== undefined && cdDriver !== null) {
      queryParameters = queryParameters.set('cdDriver', <any>cdDriver);
    }

    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization']
      );
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<DeliveryOutputDto>(
      'get',
      `${this.basePath}/api/Delivery/GetOne`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiDeliveryLoginPost(
    body?: DeliveryRequestDto,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<DeliveryResponseDto>;
  public apiDeliveryLoginPost(
    body?: DeliveryRequestDto,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<DeliveryResponseDto>>;
  public apiDeliveryLoginPost(
    body?: DeliveryRequestDto,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<DeliveryResponseDto>>;
  public apiDeliveryLoginPost(
    body?: DeliveryRequestDto,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization']
      );
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<DeliveryResponseDto>(
      'post',
      `${this.basePath}/api/Delivery/Login`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiDeliveryPostPost(
    body?: DeliveryInputDto,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<boolean>;
  public apiDeliveryPostPost(
    body?: DeliveryInputDto,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<boolean>>;
  public apiDeliveryPostPost(
    body?: DeliveryInputDto,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<boolean>>;
  public apiDeliveryPostPost(
    body?: DeliveryInputDto,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // authentication (Bearer) required
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization']
      );
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<boolean>(
      'post',
      `${this.basePath}/api/Delivery/Post`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  public getParticularOrders(
    cdDelivery: number,
    observe: 'body' = 'body',
    reportProgress: boolean = false
  ): Observable<ParticularOrderOutputDto[]> {
    let headers = this.defaultHeaders;
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization']
      );
    }
    headers = headers.set('Accept', 'application/json');
    let params = new HttpParams();
    params = params.set('cdDelivery', cdDelivery.toString());
    return this.httpClient.request<ParticularOrderOutputDto[]>(
      'get',
      `${this.basePath}/api/Delivery/GetParticularOrders`,
      {
        params,
        withCredentials: this.configuration.withCredentials,
        headers,
        observe,
        reportProgress,
      }
    );
  }

  public getParticularOrdersPaginated(
    cdDelivery: number,
    pageNumber: number = 1,
    pageSize: number = 20,
    observe: 'body' = 'body',
    reportProgress: boolean = false
  ): Observable<PaginatedParticularOrdersResponse> {
    let headers = this.defaultHeaders;
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization']
      );
    }
    headers = headers.set('Accept', 'application/json');

    let params = new HttpParams();
    params = params.set('cdDelivery', cdDelivery.toString());
    params = params.set('pageNumber', pageNumber.toString());
    params = params.set('pageSize', pageSize.toString());

    return this.httpClient.request<PaginatedParticularOrdersResponse>(
      'get',
      `${this.basePath}/api/Delivery/GetParticularOrders`,
      {
        params,
        withCredentials: this.configuration.withCredentials,
        headers,
        observe,
        reportProgress,
      }
    );
  }

  /**
   * Accept an assigned order
   * @param particularOrderId The order ID
   * @param deliveryId The delivery person ID
   */
  public acceptAssignedOrder(
    particularOrderId: number,
    deliveryId: number,
    observe: 'body' = 'body',
    reportProgress: boolean = false
  ): Observable<boolean> {
    let headers = this.defaultHeaders;
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization']
      );
    }
    headers = headers.set('Accept', 'application/json');
    let params = new HttpParams();
    params = params.set('particularOrderId', particularOrderId.toString());
    params = params.set('deliveryId', deliveryId.toString());
    return this.httpClient.request<boolean>(
      'post',
      `${this.basePath}/api/Delivery/AcceptAssignedOrder`,
      {
        params,
        withCredentials: this.configuration.withCredentials,
        headers,
        observe,
        reportProgress,
      }
    );
  }

  /**
   * Update waypoint status
   * @param orderId The order ID
   * @param waypointId The waypoint ID
   * @param status The new status ('completed' or 'cancelled')
   * @param deliveryId The delivery person ID
   */
  public updateWaypointStatus(
    orderId: number,
    waypointId: number,
    status: WaypointStatus,
    deliveryId: number,
    observe: 'body' = 'body',
    reportProgress: boolean = false
  ): Observable<boolean> {
    let headers = this.defaultHeaders;
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization']
      );
    }
    headers = headers.set('Accept', 'application/json');
    let params = new HttpParams();
    params = params.set('orderId', orderId.toString());
    params = params.set('waypointId', waypointId.toString());
    let statusParam: string;
    if (typeof status === 'number') {
      switch (status) {
        case 2:
          statusParam = 'completed';
          break;
        case 3:
          statusParam = 'cancelled';
          break;
        default:
          statusParam = status.toString();
          break;
      }
    } else {
      statusParam = status;
    }
    params = params.set('status', statusParam);
    params = params.set('deliveryId', deliveryId.toString());
    return this.httpClient.request<boolean>(
      'post',
      `${this.basePath}/api/Delivery/UpdateWaypointStatus`,
      {
        params,
        withCredentials: this.configuration.withCredentials,
        headers,
        observe,
        reportProgress,
      }
    );
  }

  /**
   * Reject an assigned order
   * @param particularOrderId The order ID
   * @param deliveryId The delivery person ID
   */
  public rejectAssignedOrder(
    particularOrderId: number,
    deliveryId: number,
    observe: 'body' = 'body',
    reportProgress: boolean = false
  ): Observable<boolean> {
    let headers = this.defaultHeaders;
    if (
      this.configuration.apiKeys &&
      this.configuration.apiKeys['Authorization']
    ) {
      headers = headers.set(
        'Authorization',
        this.configuration.apiKeys['Authorization']
      );
    }
    headers = headers.set('Accept', 'application/json');
    let params = new HttpParams();
    params = params.set('particularOrderId', particularOrderId.toString());
    params = params.set('deliveryId', deliveryId.toString());
    return this.httpClient.request<boolean>(
      'post',
      `${this.basePath}/api/Delivery/RejectAssignedOrder`,
      {
        params,
        withCredentials: this.configuration.withCredentials,
        headers,
        observe,
        reportProgress,
      }
    );
  }
}
